
import React from 'react';
import StoryKannada3to5 from 'views/StoryKannada3to5';

const StudentCornorPage = () => {
  return <StoryKannada3to5 />;
};

export default StudentCornorPage;
